import { makeFakeOrder } from "./_models/__test-utils__/order";
import { variousFakeLeakedCodes } from "./_models/__test-utils__/test-leaked-code";
import { inMemoryStubCodeUsageReader } from "./codeUsageReader/inMemoryStub";
import { tinybirdCodeUsageReader } from "./codeUsageReader/tinybird";
import { gadgetLeakedCodeReader } from "./leakedCodeReader/gadget";
import { inMemoryStubLeakedCodeReader } from "./leakedCodeReader/inMemoryStub";

export const DEPS_MODE = "live" as "live" | "testing";

export const leakedCodeReader =
  DEPS_MODE === "testing" ? inMemoryStubLeakedCodeReader([...variousFakeLeakedCodes]) : gadgetLeakedCodeReader();
export const codeUsageReader =
  DEPS_MODE === "testing"
    ? inMemoryStubCodeUsageReader([makeFakeOrder({ createdAt: new Date("2024-01-01"), id: "1" })])
    : tinybirdCodeUsageReader();
